module.exports = __webpack_public_path__ + "img/product.e445cd8f.svg";